export default __webpack_public_path__ + "static/media/Validations.bf36fb50.svg";